import type { IComponentController, IAugmentedJQuery } from 'angular';
import template from './dashboard-filters-panel.component.html';
import { DashboardPageComponent, DashboardPageController } from '../dashboard-page/dashboard-page.component';
import { EventService } from '../../App/services/event-service';
import { EventCodes } from '../../App/model/event-codes';

export class DashboardFiltersController implements IComponentController {
	public page!: DashboardPageController;
	public expanded = false;
	public containerId: string = '';

	static readonly $inject = ['mx.shell.EventService', '$element'];

	constructor(
		private readonly eventService: EventService,
		private readonly $element: IAugmentedJQuery
	) {
		this.containerId = `mx-dashboard-filters-panel--filters_id${Math.round(1000000 * Math.random())}`;
	}

	$onInit() {
		if (this.page.dashboard.filters.interactive.some((filter) => filter.required && !filter.hasValue())) {
			this.togglePanel();
		}
	}

	get filters() {
		return this.page.dashboard.filters.interactive;
	}

	applyKeyword(keyword: string) {
		this.page.applyKeywordFilter(keyword);
	}

	togglePanel() {
		this.expanded = !this.expanded;
		if (this.expanded) {
			this.$element?.find('.mx-filters-panel--button').trigger('focus');
		}
		setTimeout(() => {
			this.eventService.dispatchEvent(EventCodes.LayoutChanged);
		}, 500);
	}
}

export const DashboardFiltersComponent = {
	name: 'mxDashboardFiltersPanel',
	controller: DashboardFiltersController,
	controllerAs: 'vm',
	template,
	require: {
		page: `^${DashboardPageComponent.name}`,
	},
	bindings: {},
};
